<template>
  <div class="tw-min-h-screen tw-flex tw-flex-col tw-text-center">
    <div
      class="tw-flex tw-justify-center tw-items-center tw-min-h-screen tw-bg-gray-200 tw-p-4 ie_tw-h-screen"
    >
      <div class="tw-w-full w-360">
        <div
          class="tw-bg-white tw-shadow-md tw-rounded tw-px-8 tw-pt-6 tw-pb-8 tw-mb-4"
        >
          <p class="tw-font-semibold tw-my-4 tw-text-6xl tw-text-gray-800">
            404
          </p>
          <div class="tw-mb-4">
            <p class="tw-mb-8 tw-text-gray-700">
              Sorry, We couldn't find that page
            </p>
            <router-link
              :to="{ name: 'wall-chart' }"
              class="btn btn-blue tw-py-2 tw-no-underline"
            >
              Back
            </router-link>
          </div>
        </div>

        <auth-footer />
      </div>
    </div>
  </div>
</template>

<script>
import AuthFooter from './../../components/AuthFooter'

export default {
  name: 'NotFound',

  layout: 'DefaultLayout',

  components: { AuthFooter },
}
</script>
